import {
  Component,
  ContentChild,
  HostListener,
  Input,
  ChangeDetectionStrategy,
  ElementRef,
} from '@angular/core';

import { TableHeadersComponent } from '../table-headers/table-headers.component';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableComponent {
  @Input() useFixedHeader: boolean;
  fixedHeader = false;

  @ContentChild(TableHeadersComponent)
  tableHeaders: TableHeadersComponent;

  constructor(private el: ElementRef) {}

  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
    const scrollTop = $event.target.documentElement.scrollTop;
    const tableTop = this.el.nativeElement.offsetTop - 50;

    this.fixedHeader = scrollTop > tableTop && this.useFixedHeader;
  }
}
